import React from "react";
import { Grid, Typography, Paper, Box } from "@mui/material";

const SumUp = ({ formData }) => {
  // Group fields into sections
  const groupedData = [
    {
      title: "Informations Personnelles",
      fields: [
        { label: "Prénom", value: formData.prenom },
        { label: "Nom", value: formData.nom },
        { label: "Âge", value: formData.age },
        { label: "Taille", value: formData.taille },
        { label: "Date de Naissance", value: formData.datedenaissance },
      ],
    },
    {
      title: "Composition Corporelle",
      fields: [
        {
          label: "Pourcentage Graisse Corporelle",
          value: formData.pourcentageGraisseCorporelle ? "Oui" : "Non",
        },
        {
          label: "Pourcentage Masse Grasse",
          value: formData.pourcentageMasseGrasse,
        },
        { label: "Outil Utilisé", value: formData.masseGrasseOutil },
      ],
    },
    {
      title: "Condition Physique",
      fields: [
        {
          label: "Musculation Pratiquée",
          value: formData.musculationQuestion ? "Oui" : "Non",
        },
        { label: "Années d'Expérience", value: formData.muscuAnneeExperience },
        {
          label: "Développé Couché (kg)",
          value: formData.muscuDeveloppeCouche,
        },
        { label: "Squat (kg)", value: formData.muscuSquat },
        { label: "Tractions (répétitions)", value: formData.muscuTractions },
        { label: "Press Overhead (kg)", value: formData.muscuPressOverhead },
      ],
    },
    {
      title: "Objectifs et Style de Vie",
      fields: [
        { label: "Objectifs Fitness", value: formData.objectifsFitness },
        { label: "Profession", value: formData.profession },
        { label: "Régime Spécial", value: formData.regimeSpecial },
        { label: "Substances PED", value: formData.substancesPED },
      ],
    },
    {
      title: "Activité et Stress",
      fields: [
        { label: "Niveau d'Activité", value: formData.niveauActivite },
        { label: "Niveau de Stress", value: formData.niveauStress },
        { label: "Rythme de Sommeil", value: formData.rythmeSommeil },
        { label: "Consommation de Caféine", value: formData.cafeine },
      ],
    },
    {
      title: "Équipement",
      fields: [
        { label: "Rack à Squat", value: formData.rackSquat ? "Oui" : "Non" },
        { label: "Haltères Minimum", value: formData.minimumHalteres },
        {
          label: "Ceinture de Traction",
          value: formData.ceintureDipTraction ? "Oui" : "Non",
        },
      ],
    },
    {
      title: "Photos",
      fields: [
        {
          label: "Photo de Face",
          value: formData.photoDeFace ? "Uploaded" : "Non fourni",
        },
        {
          label: "Photo de Côté",
          value: formData.photoDeCote ? "Uploaded" : "Non fourni",
        },
        {
          label: "Photo de Dos",
          value: formData.photoDeDos ? "Uploaded" : "Non fourni",
        },
      ],
    },
  ];

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{ textAlign: "center", marginBottom: "16px" }}
      >
        Résumé de Vos Réponses
      </Typography>
      <Grid container spacing={3}>
        {groupedData.map((section, index) => (
          <Grid item xs={12} key={index}>
            <Paper elevation={3} sx={{ padding: "16px" }}>
              <Typography
                variant="h6"
                sx={{ color: "#3f51b5", marginBottom: "12px" }}
              >
                {section.title}
              </Typography>
              {section.fields.map((field, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "8px",
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    {field.label}:
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    {field.value || "Non fourni"}
                  </Typography>
                </Box>
              ))}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SumUp;
